<template>
  <div class="weather-box">{{ count }}</div>
</template>

<script>
export default {
  data() {
    return {
      count: "", //倒计时
      seconds: new Date().getTime() // 10天的秒数
    };
  },
  mounted() {
    this.ChangeTime() //调用定时器
  },
  methods: {
    // 天 时 分 秒 格式化函数
    countDown(times) {
      const date = new Date(times);
      const year = date.getFullYear();
      let moth = date.getMonth() + 1;
      moth = moth < 10 ? "0" + moth : moth;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      this.count = `${year}/${moth}/${d} ${h}:${m}:${s}`;
    },
    //定时器没过1秒参数减1
    ChangeTime() {
      setInterval(() => {
        this.seconds += 1000;
        this.countDown(this.seconds);
      }, 1000);
    },
  },
}
</script>
<style lang="less" scoped></style>
